import { createLocalStorageSeenIndicator, } from './seenIndicator';
export function createDatabaseSeenIndicator({ upsert, fetchPersisted, }) {
    const localStorageSeenIndicator = createLocalStorageSeenIndicator();
    const overridenMethods = {
        markSignatureSeen(namespace, key, signature) {
            if (localStorageSeenIndicator.getSeenSignature(namespace, key) === signature)
                return;
            localStorageSeenIndicator.markSignatureSeen(namespace, key, signature);
            upsert(namespace, key, signature).catch(err => console.error(err));
        },
        fetchAndSetPersisted: async () => {
            try {
                const persisted = await fetchPersisted();
                for (const item of persisted) {
                    localStorageSeenIndicator.markSignatureSeen(...item);
                }
            }
            catch (err) {
                console.error(err);
            }
        },
    };
    return {
        ...localStorageSeenIndicator,
        ...overridenMethods,
    };
}
//# sourceMappingURL=seenIndicatorDB.js.map